// Review/ad APIs also return yearless M/D and M/D주 labels.
// Copy first so display ordering never changes API responses or exports.
export function sortAdminNewest(rows, key = 'date') {
    const today = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(new Date());
    const dateKey = (row) => {
        const value = String(row[key] || '');
        const match = value.match(/^(\d{1,2})\/(\d{1,2})(?:주)?$/);
        if (!match) return value;
        const monthDay = `${match[1].padStart(2, '0')}-${match[2].padStart(2, '0')}`;
        // These trends end today; December labels in January belong to last year.
        const year = Number(today.slice(0, 4)) - (monthDay > today.slice(5) ? 1 : 0);
        return `${year}-${monthDay}`;
    };
    return [...(rows || [])].sort((a, b) => dateKey(b).localeCompare(dateKey(a)));
}
